// Canonical taxonomy constants shared across Documents UI.
//
// DOC_TYPE_OPTIONS is the user-facing list rendered in the Documents page
// type dropdown. Backend equivalent is DOC_TYPE_DISPLAY_MAP values in
// backend/services/scraper_overlay.py — keep this list aligned when adding
// a new canonical type.

export const DOC_TYPE_OPTIONS = [
  "Annual Report",
  "Capital Account Statement",
  "Capital Call",
  "Contract Note",
  "Distribution Notice",
  "Dividend Confirmation",
  "Financial Statement",
  "Investor Letter",
  "Market Value Statement",
  "Payment Confirmation",
  "Quarterly Report",
  "Regulatory Filing",
  "Subscription Agreement",
  "Tax Document",
];
